import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { Button } from '@mui/material'
import * as React from 'react'
import { styled } from '@mui/material/styles'
import { ModalState } from './CancelModal'
import { Link } from 'react-router-dom'
import { PATH } from '../../routes/constant'

const ModalButton = styled(Button)({
  '&:hover': {
    backgroundColor: '#09B5EC'
  }
})
interface ModalStepOneProps {
  text?: any
  onClickDecline?: any
  confirmBtn?: string
  diclineBtn?: string
  handleMode?: any
  serviceCategory?: any
  to?: any
}
const CancelModalStepOne: React.FC<ModalStepOneProps> = ({ text, onClickDecline, confirmBtn, diclineBtn, handleMode, serviceCategory, to }) => {
  return (
        <>
            <Typography id="modal-modal-description" sx={{ fontSize: '16px', fontWeight: 400, mb: '50px', textAlign: 'justify' }}>
                {text}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <Button onClick={() => { handleMode(ModalState.stepTwo) }} disableElevation sx={{ border: '2px solid #F5F6F7', color: '#6B7A99', fontSize: '12px', mb: '10px' }}>
                    {confirmBtn}
                </Button>
                {
                    (serviceCategory)
                      ? (<Link to={PATH.SUPPORT}>
                        <ModalButton disableElevation sx={{ background: '#09B5EC', border: '2px solid #09B5EC', fontSize: '12px', width: '100%' }}>
                            {diclineBtn}
                        </ModalButton>
                    </Link>)
                      : (<ModalButton onClick={ onClickDecline } disableElevation sx={{ background: '#09B5EC', border: '2px solid #09B5EC', fontSize: '12px' }}>
                            {diclineBtn}
                        </ModalButton>)
                }
            </Box>
            </>
  )
}
export default CancelModalStepOne
